import { Frame } from '../Frame';

type EmbedProps = {
  attrs: {
    href: string;
  };
};

export const Supademo = (props: EmbedProps): string => {
  return Frame({
    src: props.attrs.href,
  });
};

// Add the isMatch function for Supademo
Supademo.isMatch = (href: string): boolean => {
  const urlRegex = /^https:\/\/app\.supademo\.com\/embed\/(.*)$/;

  return urlRegex.test(href);
};
